module.exports = __webpack_public_path__ + "img/2.24a8b345.jpg";